export default __webpack_public_path__ + "static/media/osnabruck.0de6663a.jpg";